<style>
  .alert{
  transition-duration:1s; /* <= creates fade out effect */
  transition-delay:1s;
}
</style>

<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading your data ...
        </div>

        <div v-if="loading == false && (selectedMakeupArea == '' || selectedMakeupArea == null)" >
            
            <p>Where are you working today ?</p><br />
            <div class="notification is-warning" v-if="operations.length == 0">
              Loading operations ...
            </div>
            <button class="button is-large is-fullwidth  mb-4 is-info"  :disabled="loading==true" @click="updateArea(row.name)" v-for="row in operations" :key="row.id">{{ row.label }}</button>
            
            
        </div>

       
        <div v-if="loading == false && (selectedMakeupArea != '' ) && showItemsBox ==false" >
            <h2 class="title is-5">{{ selectedMakeupArea }} - 
              {{ user.firstname }} {{ user.surname }}</h2>
              
            <form  autocomplete="off" @submit.prevent="showItems()">
                <input class="input is-large" type="text" placeholder="Enter Sample Request ID here" v-model="sample_id" ref="makeup_data_input" autocomplete="off"><br /><br />
                <button class="button is-large is-fullwidth is-info" :disabled="loading==true" >Show Items</button>
                
            </form>

            <br /><br />

            
        </div>

        <div v-if="showItemsBox==true">
            <h2 class="title is-5">{{ selectedMakeupArea }} - 
              {{ user.firstname }} {{ user.surname }}</h2>

              <div class="notification is-warning" v-if="loadingSample==true">Loading ...</div>

              <div v-if="loadingSample==false">
                <p>Sample ID - {{  this.sample.id  }}<br />
                Club Name - {{ this.sample.club_name }}</p><br />
              <table class="table is-fullwidth is-striped">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Garment</th>
                          <th>Type</th>
                          <th>Qty</th>
                          <th>Extras</th>
                          <th><strong>{{ selectedMakeupArea }}</strong></th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(row, index) in sample.items" :key="row.id">
                          <td>{{  index+1 }}</td>
                          <td>{{ row.garmentname }}
                  <span v-if="row.garment_id==0"> {{ row.new_garment_name }}</span></td>
                          <td>{{ row.sample_item_type_name}}</td>
                          <td>{{ row.quantity}}</td>
                          <td class="">
                              <span class="tag mr-1" v-if="row.embroidery==1" :class="{'is-success' : row.embroidery_completed==1}">Emb.</span>
                              <span class="tag mr-1" v-if="row.trims==1" :class="{'is-success' : row.trims_completed==1}">Trims</span>
                              <span class="tag mr-1" v-if="row.dtf==1" :class="{'is-success' : row.dtf_completed==1}">DTF</span>
                              <span class="tag" v-if="row.silicon==1" :class="{'is-success' : row.silicon_completed==1}">Silcon</span>
                          </td>
                          <td>
                            <button class="button tag is-small is-link" v-if="row[selectedMakeupArea + '_completed']==1" @click="alreadyCompleted()">Completed</button>
                            <button class="button  tag is-small is-success" v-if="row[selectedMakeupArea + '_completed']==0" :disabled="working==true" @click="completeArea(row)">Complete Now</button>
                          </td>
                      </tr>
                      
                  </tbody>
              </table>
            </div>

            <br /><br />
             <button class="button is-large is-fullwidth is-info" :disabled="loading==true || loadingSample==true "  @click="resetForm()">Search For Another Sample</button>
        </div>

        

            <br />
            <button class="button is-large is-fullwidth is-warning" :disabled="loading==true" @click="updateArea('')">Change Operation</button>
            
        

        
        
    </div>
</template>

<script>
import SampleService from '@/services/SampleService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'DataInputMakeup',
  mixins: [OrderMixin],
  data() {
    
    return {
      sample: {},
      sample_id: '',
      loading: false,
      working: false,
      access_token: '',
      processed:false,
      actions_log : [],
      operations: [
      {'id':10, 'label':'Patterns', 'name':'cutsew_pattern'},  
      {'id':1, 'label':'Artwork', 'name':'artwork'}, 
          {'id':2, 'label':'Digital Print', 'name':'digital_print'},
          {'id':3, 'label':'Gerber Cutting', 'name':'gerber_cutting'},
          {'id':11, 'label':'Cut/Sew Cutting', 'name':'cutsew_cutting'},
          {'id':4, 'label':'Sundries', 'name':'sundries'},  
           {'id':5, 'label':'Makeup', 'name':'makeup'}, 
          {'id':6, 'label':'Embroidery', 'name':'embroidery'},
           {'id':7, 'label':'Silicon', 'name':'silicon'}, 
           {'id':8, 'label':'DTF', 'name':'dtf'}, 
           {'id':9, 'label':'Knitted Trims', 'name':'trims'}, 
           {'id':12, 'label':'Despatch', 'name':'despatch'}, 
           
           ], 
      user: [],
      showItemsBox: false,
      selectedMakeupArea: '',
      loadingSample: false
    }
  },
   methods: {
    alreadyCompleted() {
      alert('This item has already been completed')
    },  
    showItems() {
      
        this.showItemsBox = true

        this.getSample();
    },
    resetForm() {
      this.sample_id = ''
      this.showItemsBox = false
    },
    async getSample() {
            this.loadingSample=true
            SampleService.getSample(this.accessToken, this.sample_id)
            .then(
                (sample => {
                    this.$set(this, "sample", sample);
                    this.loadingSample=false
                    
                }).bind(this)
            );
        },
        async completeArea(sample_item) {
            this.working=true

            var area = this.selectedMakeupArea.toLowerCase();

            var formdata = { 
                area: area
            }; 

            SampleService.completeSampleItemArea(this.accessToken, sample_item.id, formdata)
            .then(() => {
              this.working=false;
              
              sample_item[area + "_completed"] = 1
            }).catch((error) => {
              if(error.response.status == 409)
              {
                alert("It looks like that area has already been completed for this item")
                  console.log("Error:" + JSON.stringify(error.response.data));
              }
              else {
                alert("Something went wrong and the sample has not been updated. Please reload and try again")
                  console.log("Error:" + JSON.stringify(error.response.data));
              }
               this.working = false
            }); 
            
        },      
      updateArea(value) {
        
        this.selectedMakeupArea = value

        if(value != '' && this.sample_id > 0)
        {
          
          this.getSample();
          this.showItemsBox = true
        }
        else {
          this.showItemsBox = false
        }
       
      },
      updateLocation(value) {
        this.loading=true
        this.makeup_input_location_id = value
        this.loading = false;

        if(this.makeup_input_location_id != '')
        {
            this.focusInput()
        }
        
      },
      focusInput() {
          this.$nextTick(() => this.$refs.makeup_data_input.focus())
      }
     
   },
   mounted() {
       if (localStorage.samples_makeup_area) {
      this.selectedMakeupArea = localStorage.samples_makeup_area;
    }
    else{
      this.selectedMakeupArea = ''
    }

    if (localStorage.makeup_input_location_id) {
      this.makeup_input_location_id = localStorage.makeup_input_location_id;
    }
    else{
      this.makeup_input_location_id = ''
    }

    this.focusInput();
    
  },
  
  watch: {
    selectedMakeupArea: function () {
     localStorage.samples_makeup_area = this.selectedMakeupArea;
      
    },

    makeup_input_location_id: function () {
     localStorage.makeup_input_location_id = this.makeup_input_location_id;
      
    },
    
    
  },
  created() {
     this.getAccessToken()
        .then(() => { 
          this.getUserProfile();
         // this.getOperations();
        });

        
  },
}
</script>